import { NgModule } from '@angular/core';
import { ContextBarComponent } from './context-bar.component';
import { ElementsModule } from '@shared/elements/elements.module';
import { CommonModule } from '@angular/common';
import { FormValidationModule } from '@components/form-validation/form-validation.module';
import { PortalModule } from '@angular/cdk/portal';
import { ContextBarDynamicPlaceholderComponent } from './dynamic-placeholder/context-bar-dynamic-placeholder.component';
import { ContextBarDirectiveModule } from '@shared/directives/context-bar/context-bar.directive.module';

@NgModule({
    declarations: [ContextBarComponent, ContextBarDynamicPlaceholderComponent],
    imports: [
        ElementsModule,
        CommonModule,
        FormValidationModule,
        PortalModule,
        ContextBarDirectiveModule
    ],
    exports: [ContextBarComponent],
    providers: [],
})
export class ContextBarModule {}
